import queryProducts from './lib/queryProducts.js'
import fetchProductCatalog from './lib/fetchProductCatalog.js'
import storeProductCatalogTaxonomies from './lib/storeProductCatalogTaxonomies.js'
import applogger from '@applogger'

// Product Loaders
import loadProductImages from './utils/loadProductImages'

function asyncLoader(store, catalogue = '') {
  return fetchProductCatalog(store)
    .catch(() => queryProducts(store))
  // return queryProducts(store)
    .then((response) => {
      if (Object.prototype.hasOwnProperty.call(response, 'data')) {
        const requestResults = response.data
        storeProductCatalogTaxonomies(requestResults, store)
        store.dispatch('products/loadAllMaps', requestResults)
        return requestResults.products ?? []
      }
      else {
        const errorMessage = Object.prototype.hasOwnProperty.call(response, 'errors') && response.errors.length > 0
          ? `Error loading Products:`
          : 'Something went wrong while attempting to load products.'

        applogger.error(errorMessage)

        if (Object.prototype.hasOwnProperty.call(response, 'errors')) {
          response.errors.map(error => applogger.error(error))
        }

        return []
      }
    })
    .then((products) => {
      if (products.length > 0) {
        let maps = []
        let alteredProducts = JSON.parse(JSON.stringify(products))

        for (let i = 0; i < alteredProducts.length; i++) {
          maps.push(store.dispatch('products/detectAndMapProduct', alteredProducts[i]))
        }

        return Promise.all(maps)
          .then((mappedProducts) => {
            store.dispatch('products/storeProducts', mappedProducts)
            loadProductImages(mappedProducts, store)
          })
      }
      else {
        return []
      }
    })
    .catch(err => {
      applogger.log(err)
      return []
    })
}

export { asyncLoader }
